import React, {Component} from "react";
import {introAssetConfig} from "../../../data/intro"
import {configGame} from "../../../data/config";
import {autoplayAssetConfig} from "../../../data/autoplay/autoplayconfig";
import {objectTypes} from "../../buttonpanel/interface/Ibuttons";


interface IframeworkDesktopSettingPanel {
    data: {}
}

export const frameworkDesktopSettingPanel: IframeworkDesktopSettingPanel = {
    data: {
        "COMPONENTS": []
    }


};

export const DesktopSettingPanelConfigurationContext = React.createContext(
    {}
);